import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, Trophy, ArrowRight } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { ShowcaseFilms } from "../components/showcase/ShowcaseFilms";
import { api, BACKEND_URL } from "../lib/api";

export default function HallOfFamePage() {
  const [archive, setArchive] = useState([]);
  useEffect(() => {
    api.get("/featured-couple/archive").then((r) => setArchive(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-[var(--bg)] min-h-screen">
      <Navbar />
      <section className="relative section-pad bg-[var(--bg-warm)]">
        <div className="container-wide px-6 md:px-12 text-center">
          <Trophy className="w-8 h-8 mx-auto text-[var(--gold)] mb-4" />
          <p className="font-script text-[var(--gold)] text-4xl mb-2">Hall of Fame</p>
          <h1 className="font-serif font-light text-5xl md:text-7xl">Featured Couples</h1>
          <p className="text-[var(--muted)] mt-4 max-w-xl mx-auto">Every week we celebrate one couple's love story. Browse the archive of locked-in legends.</p>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-wide px-6 md:px-12">
          {archive.length === 0 ? (
            <div className="text-center py-20"><Star className="w-10 h-10 mx-auto text-[var(--gold)] mb-4" /><p className="font-serif text-2xl">The first chapter is being written.</p><p className="text-[var(--muted)] mt-2">Check back soon — your love story could be next.</p></div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {archive.map((p, i) => {
                const photo = p.photo_url ? (p.photo_url.startsWith("http") ? p.photo_url : `${BACKEND_URL}/api/files/${p.photo_url}`) : "https://images.pexels.com/photos/33403878/pexels-photo-33403878.jpeg?w=600";
                return (
                  <Link key={`${p.week_start}-${p.wedding.wedding_id}`} to={`/site/${p.wedding.slug}`} data-testid={`hall-${i}`} className="group">
                    <div className="luxe-image relative">
                      <img src={photo} alt={p.wedding.couple_names} className="w-full h-72 object-cover group-hover:scale-105 transition-transform duration-700" />
                      <div className="absolute top-4 left-4 glass-light rounded-full px-3 py-1 flex items-center gap-1"><Star className="w-3 h-3 text-[var(--gold)]" /><span className="text-[10px] uppercase tracking-wider">Week of {p.week_start}</span></div>
                    </div>
                    <p className="font-script text-3xl text-[var(--gold)] mt-4">{p.wedding.couple_names}</p>
                    {p.wedding.wedding_date && <p className="text-xs uppercase tracking-[0.18em] text-[var(--muted)]">{new Date(p.wedding.wedding_date).toLocaleDateString()}{p.wedding.city ? ` · ${p.wedding.city}` : ""}</p>}
                    {p.story && <p className="text-sm text-[var(--muted)] mt-3 line-clamp-2">{p.story}</p>}
                    <p className="text-sm text-[var(--gold)] mt-3 flex items-center gap-1">Visit site <ArrowRight className="w-3 h-3" /></p>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </section>

      <ShowcaseFilms />
      <Footer />
    </div>
  );
}
